import bem from 'utils/bem';

export const block = bem('add-media-modal');
export const searchResultsBlock = bem('search-results');
